import {Module} from 'react-360-web';

export default class ObservableStateModule extends Module {
    constructor() {
        super('ObservableStateModule');
        this.actionObservers = {};
        this.observers = [];
    }

    addObserver(observer, action) {
        if (action) {
            this._addActionObserver(observer, action);
        } else {
            this._addObserver(observer);
        }
    }

    _addActionObserver(observer, action) {
        let actionObservers = this.actionObservers[action];
        if (!actionObservers) {
            actionObservers = [];
            this.actionObservers[action] = actionObservers;
        }
        actionObservers.push(observer);
    }

    _addObserver(observer) {
        this.observers.push(observer);
    }

    removeObserver(observer, action) {
        if (action) {
            this._removeActionObserver(observer, action);
        } else {
            this._removeObserver(observer);
        }
    }

    _removeActionObserver(observer, action) {
        let actionObservers = this.actionObservers[action];
        if (actionObservers) {
            this.actionObservers[action] = actionObservers.filter((other) => {
                return observer !== other;
            });
        }
    }

    _removeObserver(observer) {
        this.observers = this.observers.filter((other) => {
            return observer !== other;
        });
    }

    notify(data, action) {
        let actionObservers = this.actionObservers[action];
        if (actionObservers) {
            if (actionObservers.length > 0) {
                actionObservers.forEach((observer) => {
                    setTimeout(() => observer.update(data));
                });
            }
        }
        this.observers.forEach((observer) => {
            setTimeout(() => observer.update(data));
        });
    }
}
